import $ from 'jquery';
import powertip from 'jquery-powertip';

const tooltip = function() {

    if($('#mpn_id_tooltip').length) {
        $('#mpn_id_tooltip').data('powertipjq', $([
            '<p><a target="_blank" href="https://login.live.com/login.srf?wa=wsignin1.0&rpsnv=13&ct=1560251826&rver=6.2.6289.0&wp=MBI_SSL&wreply=https:%2F%2Fpartners.microsoft.com%2FPartnerProgram%2Fsimplifiedenrollment.aspx&lc=1049&cb=wreply%3Dhttps%253a%252f%252fpartners.microsoft.com%252fPartnerProgram%252fsimplifiedenrollment.aspx&id=41460">Можно получить по ссылке</a></p>'
        ].join('\n')));

        $('#mpn_id_tooltip').powerTip({
            placement: 'n',
            mouseOnToPopup: true
        });
    }

    if($('#kr_pin_tooltip').length) {
        $('#kr_pin_tooltip').data('powertipjq', $([
            '<p><a target="_blank" href="https://partners.kaspersky.com/s/login/?language=ru&startURL=%2Fs%2F&ec=302">Можно получить по ссылке</a></p>'
        ].join('\n')));

        $('#kr_pin_tooltip').powerTip({
            placement: 'n',
            mouseOnToPopup: true
        });
    }

    if($('#eset_id_tooltip').length) {
        $('#eset_id_tooltip').data('powertipjq', $([
            '<p><a target="_blank" href="https://www.esetnod32.ru/partners/request-id/">Можно получить по ссылке</a></p>'
        ].join('\n')));

        $('#eset_id_tooltip').powerTip({
            placement: 'n',
            mouseOnToPopup: true
        });
    }
};

export default tooltip;